// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"d5117050","455":"95e7b6eb","977":"c090f661"}[chunkId] + ".chunk.js";
};